import EzCancel from '@/src/assets/svgs/Ezcancel'
import Flexifly from '@/src/assets/svgs/Flexifly'
import { INTL_CANCELATION_INSURANCE } from '@/src/constants/itnerary'
import { Fare } from '@/src/types/itinerary'
import { TranslationFunction } from '@/src/types/translations'
import { Box, Card, CardContent, Checkbox, Typography } from '@mui/material'

interface FareCardsProps {
    fares: Fare[]
    onFareSelect: (fare: Fare) => void
    formatFareTitle: (title: string) => string
    formatCurrency: (price: number) => string
    t: TranslationFunction<'common'>
}

const VasForFareFamily: React.FC<FareCardsProps> = ({ fares, onFareSelect, formatFareTitle, formatCurrency, t }) => {
    return (
        <Box>
            <Typography
                variant="h6"
                sx={{
                    fontWeight: 600,
                    mb: 2,
                    color: 'textColors.primary',
                    fontSize: { xs: '16px', md: '1.25rem' }
                }}
            >
                {t('uncertainOfPlans')}
            </Typography>

            <Box
                sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', lg: 'row' },
                    gap: 1.5,
                    alignItems: 'stretch',
                    '& > *': {
                        flex: { lg: '1 1 0%' },
                        minWidth: 0
                    }
                }}
            >
                {fares.map((fare, index) => {
                    const { fareMetaMessages, selected, totalPremiumAmount = 0 } = fare
                    const fareMetaMessage = fareMetaMessages?.[0] || {}
                    const { title, category, messages = [] } = fareMetaMessage || {}
                    const isEzCancel = category === INTL_CANCELATION_INSURANCE

                    return (
                        <Card
                            key={index}
                            sx={{
                                position: 'relative',
                                borderRadius: 2,
                                border: '1px solid',
                                borderColor: 'grey.300',
                                backgroundColor: 'white',
                                cursor: 'pointer',
                                transition: 'all 0.2s ease-in-out',
                                display: 'flex',
                                flexDirection: 'column',
                                overflow: 'hidden'
                            }}
                            onClick={() => onFareSelect(fare)}
                        >
                            <CardContent
                                sx={{
                                    p: { xs: 2, md: 2.5 },
                                    display: 'flex',
                                    gap: 1.5,
                                    height: '100%',
                                    '&:last-child': { pb: { xs: 2, md: 2.5 } }
                                }}
                            >
                                <Box
                                    sx={{
                                        width: { xs: 24, md: 28 },
                                        height: { xs: 24, md: 24 },
                                        borderRadius: '50%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        flexShrink: 0
                                    }}
                                >
                                    {isEzCancel ? (
                                        <EzCancel sx={{ fontSize: 20 }} />
                                    ) : (
                                        <Flexifly sx={{ fontSize: 20 }} />
                                    )}
                                </Box>

                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'flex-start',
                                        flex: 1
                                    }}
                                >
                                    <Typography
                                        variant="h6"
                                        sx={{
                                            color: 'text.primary',
                                            fontWeight: 600,
                                            fontSize: { xs: '1rem', md: '1.125rem' },
                                            lineHeight: 1.2,
                                            mb: 1
                                        }}
                                    >
                                        {formatFareTitle(title)}
                                    </Typography>

                                    {messages && messages.length > 0 && (
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                flex: 1,
                                                color: 'text.secondary',
                                                fontSize: { xs: '0.875rem', md: '0.9rem' },
                                                lineHeight: { xs: 1.4, md: 1.3 },
                                                mb: 2
                                            }}
                                        >
                                            {messages[0]}
                                        </Typography>
                                    )}

                                    <Box
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'baseline',
                                            justifyContent: 'space-between',
                                            gap: 1
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                fontWeight: 700,
                                                fontSize: { xs: '1.25rem', md: '1.375rem' }
                                            }}
                                        >
                                            {formatCurrency(totalPremiumAmount)}
                                        </Typography>

                                        {/* <Typography
                                            variant="body2"
                                            sx={{
                                                color: 'primary.main',
                                                fontSize: { xs: '0.875rem', md: '0.9rem' },
                                                fontWeight: 500,
                                                cursor: 'pointer'
                                            }}
                                        >
                                            {t('viewBenefits')}
                                        </Typography> */}
                                    </Box>
                                </Box>

                                <Box
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'flex-end',
                                        alignItems: 'flex-start'
                                    }}
                                >
                                    <Checkbox
                                        checked={selected}
                                        sx={{
                                            color: 'grey.400',
                                            '&.Mui-checked': {
                                                color: 'primary.main'
                                            },
                                            p: 0
                                        }}
                                    />
                                </Box>
                            </CardContent>
                        </Card>
                    )
                })}
            </Box>
        </Box>
    )
}

export default VasForFareFamily
export type { FareCardsProps }
